import Axios from 'axios'
import baseURL from '@/config/index'
import {
  Message,
  Loading
} from 'element-ui';
import {
  getToken,
  setToken
} from '@/libs/util'
class httpRequest {
  constructor() {
    //this.Loading = {}
    this.options = {
      method: '',
      url: ''
    }
    // 存储请求队列
    this.queue = {}
  }
  // 销毁请求实例
  destroy(url) {
    delete this.queue[url]
    const queue = Object.keys(this.queue)
    return queue.length
  }
  // 请求拦截
  interceptors(instance, url) {
    // 添加请求拦截器
    instance.interceptors.request.use(config => {

      if (!config.url.includes('pub-unitUserLoginin')) {
        config.headers['Authorization'] = getToken()
      }

      // 在发送请求之前做些什么
      return config
    }, error => {
      // 对请求错误做些什么
      return Promise.reject(error)
    })

    // 添加响应拦截器
    instance.interceptors.response.use((res) => {
      let {
        data
      } = res
      if (data.new_access_token) {
        //替换token
        setToken(data.new_access_token)
      }
      // const is = this.destroy(url)
      // if (!is) {
      //     setTimeout(() => {
      //         // Spin.hide()
      //     }, 500)
      // }
      if (data.code !== 200) {
        // 后端服务在个别情况下回报201，待确认
        if (data.code === 401 || data.code === -996) {
          sessionStorage.removeItem('token')
          
          Message.error({
            content: '登录信息已过期，请重新登录~',
            onClose: () => {
              window.location.href = window.location.origin + '/login'

            }
          })
        } else {

          if (data.msg && data.msg != '') {
            Message.error(data.msg)
          }
        }
        // return false
      }


      return data
    }, (error) => {
      alert('服务内部错误！')
      // 对响应错误做点什么
      return Promise.reject(error)
    })
  }
  // 创建实例
  create() {
    let conf = {
      baseURL: baseURL,
      // timeout: 2000,
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        //'X-URL-PATH': location.pathname
      }
    }
    return Axios.create(conf)
  }

  // 合并请求实例
  mergeReqest(instances = []) {
    //
  }
  // 请求实例
  request(options) {
    var instance = this.create()
    this.interceptors(instance, options.url)
    options = Object.assign({}, options)
    this.queue[options.url] = instance
    return instance(options)
  }
}
export default httpRequest



// WEBPACK FOOTER //
// ./src/libs/axios.js